<footer [ngClass]="{ 'pt-5 pb-2': !isSoloMode }">
  <div class="container">
    <div class="row">
      <div *ngIf="footerLogo" class="col-12 col-md-6 my-2 d-flex align-items-center justify-content-center powered">
        <span class="mr-2">Powered by</span>
        <a href="/" target="_blank" class="text-white p-2 powered__go-button">WineristGO!</a>
      </div>

      <div class="col-12 col-md-6 my-2 d-flex align-items-center justify-content-center">
        <img [src]="baseUrl + 'assets/images/master-card-logo.svg'" alt="Mastercard" class="card" />
        <img [src]="baseUrl + 'assets/images/visa-logo.svg'" alt="Visa" class="card" />
        <img [src]="baseUrl + 'assets/images/american-express.png'" alt="American Express" class="card" />
      </div>
    </div>
  </div>
</footer>
